import React from "react";

import { AdminSection, Col, Option, Row, Select } from "components";

export const MethodRecommendationsTab = ({ method, t }) => {
  const cropsEnum = t("enums:crops", { returnObjects: true });
  const livestockEnum = t("enums:livestock", { returnObjects: true });
  const additionsEnum = t("enums:additions", { returnObjects: true });

  return (
    <>
      <AdminSection
        headline="Recommendation parameters"
        description={
          <>
            Select ALL of the options that apply when a user goes through the content recommendations. For example, selecting 'yes' and 'no' will result in any
            user who selects either option receiving the recommendation.
          </>
        }
      />
      <Row>
        <Col>
          <Select
            name="crops"
            label="Select crops"
            rules={[{ required: true }]}
            initialValue={method && method.crops}
            mode="multiple"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {Object.keys(cropsEnum).map((k) =>
              cropsEnum[k].map((item, i) => (
                <Option value={item} key={`${k}${i}`}>
                  {item}
                </Option>
              ))
            )}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <Select
            name="livestock"
            label="Select livestock options"
            rules={[{ required: true }]}
            initialValue={method && method.livestock}
            mode="multiple"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {Object.keys(livestockEnum).map((k) =>
              livestockEnum[k].map((item, i) => (
                <Option value={item} key={`${k}${i}`}>
                  {item}
                </Option>
              ))
            )}
          </Select>
        </Col>
        <Col sm={12} md={12}>
          <Select
            name="additions"
            rules={[{ required: true }]}
            initialValue={method && method.additions}
            mode="multiple"
            showSearch
            label="Select additional options"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {Object.keys(additionsEnum).map((k) =>
              additionsEnum[k].map((item, i) => (
                <Option value={item} key={`${k}${i}`}>
                  {item}
                </Option>
              ))
            )}
          </Select>
        </Col>
      </Row>
    </>
  );
};
